"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerAreaTrigger = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const hooks_1 = require("../../../../hooks");
const CustomerSalutation_1 = require("../CustomerSalutation");
const CustomerAreaRecognizedTrigger_1 = require("./CustomerAreaRecognizedTrigger");
const CustomerUnloggedTrigger_1 = require("./CustomerUnloggedTrigger");
const CustomerAreaTrigger = ({ reseller }) => {
    const { isLogged, isRecognized, customerId } = (0, hooks_1.useCustomer)();
    if (!isRecognized || !customerId)
        return (0, jsx_runtime_1.jsx)(CustomerUnloggedTrigger_1.CustomerUnloggedTrigger, { reseller: reseller });
    return ((0, jsx_runtime_1.jsx)(core_1.Box, Object.assign({ style: {
            marginTop: '0.125rem',
        } }, { children: isLogged ? ((0, jsx_runtime_1.jsx)(CustomerSalutation_1.CustomerSalutation, {})) : ((0, jsx_runtime_1.jsx)(CustomerAreaRecognizedTrigger_1.CustomerAreaRecognizedTrigger, { customerId: customerId, reseller: reseller })) })));
};
exports.CustomerAreaTrigger = CustomerAreaTrigger;
